module.exports = __webpack_public_path__ + "static/media/benefits_mentor.8df82dd8.svg";